/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


define('modules/Quote/QuoteManager',[
    'jquery',
    'global/all',
    'plugins/jquery.proxyRequest'
], function ($, Roc) {
    'use strict';

    /**
     * Requests api to create quote from current shopping cart
     * @param {} quoteRequest
     * @returns {} 
     */
    function requestQuote() {
        var createQuoteRequest = {
            OrderId: '{orderId}'
        };

        return $.proxyRequest({
            type: 'POST',
            url: '/api/quote/',
            data: JSON.stringify(createQuoteRequest),
            serverCompleteAction: 'SetCurrentQuoteId',
            dataType: 'json',
            complete: function (xhr) {
                Roc.Logger.info('QuoteManager -> requestQuote');
                Roc.Logger.info(xhr);
                var response = xhr.responseJSON || {};

                response.success = xhr.status === 200;

                Roc.EventManager.notify(Roc.Events.quote.QUOTE_CREATED, response);
            }
        });
    }

    /**
     * Requests api to update quote shipping details
     * @param {} estimateShippingRequest 
     * @param {} requestType
     * @param {} requestCustomFields - dictiornary of <string, object> for passing custom fields to API
     * @returns {} 
     */
    function updateShippingDetails(shippingRequest, requestType, requestCustomFields) {
        shippingRequest.requestType = requestType;
        shippingRequest
            .requestCustomFields = requestCustomFields;

        return $.proxyRequest({
            type: 'POST',
            url: '/api/quote/shippingdetails',
            data: JSON.stringify(shippingRequest),
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            complete: function (xhr) {
                Roc.Logger.info('QuoteManager -> updateShippingDetails');
                Roc.Logger.info(xhr);
                Roc.EventManager.notify(Roc.Events.quote.UPDATE_SHIPPING_DETAILS, { xhr: xhr, request: shippingRequest });
            }
        });
    }

    /**
    * Requests api to get current quote
    * @returns {} 
    */
    function getCurrentQuote(forceRecalculate, requestCustomFields) {
        forceRecalculate = forceRecalculate || false;

        var request = {
            quoteId: '{quoteId}',
            forceRecalculate: forceRecalculate,
            requestCustomFields: requestCustomFields
        };

        return $.proxyRequest({
            type: 'POST',
            dataType: 'json',
            contentType: 'application/json; charset=utf-8',
            url: '/api/quote/get',
            data: JSON.stringify(request),
            complete: function (xhr) {
                Roc.Logger.info('QuoteManager -> getCurrentQuote');
                Roc.Logger.info(xhr);
                var response = xhr.responseJSON || {};
                Roc.EventManager.notify(Roc.Events.quote.GET_CURRENT_QUOTE, response);
            }
        });
    };

    /**
     * 
     * @param {} request - submits filled form from quote request page and change quote status to from new to pending
     * @returns {} 
     */
    function submitQuote(request) {
        return $.proxyRequest({
            url: '/api/quote/submit',
            data: JSON.stringify(request),
            type: 'PUT',
            dataType: 'json',
            contentType: 'application/json'
        });
    }

    /**
     * This function adds particular product in reuqested quantity to quote
     * @param {} productId - ID of product to add
     * @param {} quantity
     * @param {} groupId - ID of group product from which context this item is being added (i.e. group product landing page)
     * @param {} uomId
     * @param {} deliveryOptions - delivery options for item
     * @param {} upchargeData
     * @param {} requestCustomFields - dictiornary of <string, object> for passing custom fields to API
     * @returns {} 
     */
    
    function addQuoteItem(productId, quantity, groupId, uomId, deliveryOptions, upchargeData, requestCustomFields) {
        if (!quantity) {
            quantity = 1;
        }        
        var addToQuoteRequest = {
            'productId': productId,
            'quantity': quantity,
            'quoteId': '{quoteId}',
            'RemoteIP': '{RemoteIP}'
        }

        if (groupId) {
            addToQuoteRequest.groupId = groupId;
        }

        if (deliveryOptions) {
            addToQuoteRequest.deliveryOptions = deliveryOptions;
        }

        if (upchargeData) {
            addToQuoteRequest.upchargeData = {};

            _.each(upchargeData, function (value, key) {
                var request = {
                    code: value.code,
                    upchargeAmount: value.upchargeAmount,
                    json: value.json,
                };

                if ($.type(request.json) !== "string") {
                    request.json = JSON.stringify(request.json);
                }

                addToQuoteRequest.upchargeData[key] = request;
            });
        }

        if (uomId) {
            addToQuoteRequest.uomId = uomId;
            addToQuoteRequest.uomQuantity = quantity;
        }

        addToQuoteRequest.requestCustomFields = requestCustomFields;

        return $.proxyRequest({
            type: 'PUT',
            url: '/api/quote/item/',
            data: JSON.stringify(addToQuoteRequest),
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            serverCompleteAction: 'SetCurrentQuoteId',
            complete: function (xhr) {
                Roc.Logger.info('QuoteManager -> addQuoteItem');
                Roc.Logger.info(xhr);
                var response = xhr.responseJSON || {};
                
                Roc.EventManager.notify(Roc.Events.quote.ADD_TO_QUOTE, response);
            }
        });
    }

    /**
     * A module for making quote api requests
     * @exports QuoteManager
     */
    var QuoteManager = {
        getCurrentQuote: getCurrentQuote,
        updateShippingDetails: updateShippingDetails,
        requestQuote: requestQuote,
        submitQuote: submitQuote,
        addQuoteItem: addQuoteItem
    };

    Roc.Logger.debug('QuoteManager.js Loaded:', QuoteManager);

    return QuoteManager;
});
